exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".src-components-common-check-box-___check-box__container___zRLi7 {\n  margin-left: 12px;\n}\n\n.src-components-common-check-box-___check-box__container___zRLi7 label {\n  height: 22px !important;\n  line-height: 22px !important;\n}\n\n.src-components-common-check-box-___check-box__center___29GOV {\n  margin-top: auto !important;\n  margin-bottom: auto  !important;\n}", ""]);

// exports
exports.locals = {
	"container": "src-components-common-check-box-___check-box__container___zRLi7",
	"center": "src-components-common-check-box-___check-box__center___29GOV"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!./~/resolve-url-loader!./~/sass-loader!./src/components/common/check-box/check-box.scss
// module id = 1459
// module chunks = 0